import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'preview-placeholder',
  templateUrl: './preview-placeholder.component.html',
  encapsulation: ViewEncapsulation.None
})
export class PreviewPlaceholderComponent {
  @Input() className?: string;
}